import { defineStore } from 'pinia';
import store from '@/store';
import { getUserInfo, loginApi, get_user_list2, sales_area, get_my_list } from '@/api/apis';
import { randomColor } from '@/util/index';
export var useUserStore = defineStore('useUserStore', () => {
  var isFouce = ref('');
  var notice_detail_item = ref('');
  function route_push_path(children) {
    var newArr = children.map(x => {
      x.path = x.pc_path;
      if (x.child && x.child.length != 0 && x.type == 2) {
        x.child = route_push_path(x.child);
      }
      return x;
    });
    return newArr;
  }
  var token = localStorage.getItem('token_blk') || '';
  var info = ref('');
  var routes = ref('');
  routes.value = localStorage.getItem('rotues_blk') && JSON.parse(localStorage.getItem('rotues_blk')) || '';
  var user_list = ref('');
  var email = ref('');
  var email_pwd = ref(true);
  var info_route = ref('');
  var notify_count = ref('');
  var todoData = ref(null);
  function get_user_list_fn() {
    return new Promise((resolve, reject) => {
      if (user_list.value) {
        resolve(user_list.value);
      } else {
        get_user_list2({
          page: 1,
          limit: 1,
          is_simple: 1
        }).then(res => {
          if (res.code == 200) {
            return res.data.total;
          }
        }).then(total => {
          if (total) {
            get_user_list2({
              page: 1,
              limit: total,
              is_simple: 1
            }).then(res => {
              if (res.code == 200) {
                user_list.value = res.data.data;
                resolve(user_list.value);
              }
            });
          }
        });
      }
    });
  }
  // 获取用户数组
  var user_list_color = ref({});
  function set_user_color(arr) {
    arr.map(x => {
      if (!user_list_color.value[x.uid]) {
        user_list_color.value[x.uid] = randomColor();
      }
    });
  }
  function login(params) {
    return new Promise((resolve, reject) => {
      loginApi(params).then(response => {
        if (response.code == 200) {
          if (response.data.token) {
            localStorage.setItem('token_blk', response.data.token);
            token = response.data.token;
          }
          resolve(response);
        }
      }).catch(err => {
        reject(err);
      });
    });
  }
  function format_routes(routes) {
    if (routes.findIndex(x => x.code == 2200) == -1) {
      notify_count.value = 0;
    }
    if (routes && routes.length != 0) {
      routes.forEach(item => {
        if (item.code == 2200) {
          notify_count.value = item.notice;
        }
        item.icon = get_icon(item.code);
      });
      return routes;
    } else {
      notify_count.value = '';
      return [];
    }
  }
  function get_icon(code) {
    code = Number(code);
    var icon = '';
    switch (code) {
      case 10:
        icon = 'icon-shouye';
        break;
      case 40:
        icon = 'icon-caozuorizhi';
        break;
      case 100:
        icon = 'icon-xinfengtianchong';
        break;
      case 200:
        icon = 'icon-caidan';
        break;
      case 300:
        icon = 'icon-chanpinguanli';
        break;
      case 2100:
        icon = 'icon-kucunguanli';
        break;
      case 2200:
        icon = 'icon-xiaoxi2';
        break;
      case 30:
        icon = 'icon-rili';
        break;
      case 20:
        icon = 'icon-zixun';
        break;
      case 9000:
        icon = 'icon-caigoushenqing';
        break;
      case 2710:
        icon = 'icon-yanfaguanli-xiangmuguanli';
        break;
      case 3000:
        icon = 'icon-icon-test';
        break;
      case 3800:
        icon = 'icon-daohang-caiwuguanli';
        break;
      case 10000:
        icon = "icon-app_sl";
        break;
      default:
        break;
    }
    return icon;
  }
  function getInfo() {
    return new Promise((resolve, reject) => {
      getUserInfo().then(response => {
        response = response;
        if (response.code == 200) {
          info.value = response.data.info;
          info.value.task_num = Number(info.value.task_num);
          routes.value = route_push_path(format_routes(response.data.routes));
          localStorage.setItem('rotues_blk', JSON.stringify(routes.value));
          localStorage.setItem("userinfo", JSON.stringify(info.value));
          response.data.routes = routes.value;
          info_route.value = response;
        }
        resolve(response);
      });
    });
  }
  function getRoutes() {
    return new Promise((resolve, reject) => {
      if (routes.value) {
        resolve(routes.value);
      } else {
        getInfo().then(response => {
          if (response.code == 200) {
            resolve(response.data.routes);
          }
        });
      }
    });
  }
  function clear_userInfo() {
    routes.value = '';
    info.value = '';
    user_list_color.value = {};
    info_route.value = '';
  }
  var sales_area_list = ref([]);
  function sale_area_list() {
    console.log('执行11111');
    return new Promise((resolve, reject) => {
      var _sales_area_list$valu;
      if (((_sales_area_list$valu = sales_area_list.value) === null || _sales_area_list$valu === void 0 ? void 0 : _sales_area_list$valu.length) != 0) {
        resolve(sales_area_list.value);
      } else {
        getInfo().then(userinfo => {
          sales_area({
            interface: 'get_user_data_auth_detail',
            group_type: 1,
            userid: userinfo.data.info.id,
            page: 1,
            limit: 240
          }).then(res => {
            if (res.code == 200) {
              sales_area_list.value = res.data.list;
              resolve(sales_area_list.value);
            }
          });
        });
      }
    });
  }

  // 获取待我处理
  function get_my_list_fn(params) {
    return new Promise((resolve, reject) => {
      get_my_list(params).then(res => {
        todoData.value = (res === null || res === void 0 ? void 0 : res.data) || null;
        resolve(res);
      });
    });
  }
  return {
    info,
    routes,
    user_list_color,
    info_route,
    notify_count,
    notice_detail_item,
    sale_area_list,
    login,
    getInfo,
    get_user_list_fn,
    set_user_color,
    getRoutes,
    clear_userInfo,
    email,
    email_pwd,
    isFouce,
    get_my_list_fn,
    todoData
  };
});

// 非setup
export function useUserStoreHook() {
  return useUserStore(store);
}